import React, { useState } from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import { testimonialData } from './Testimonials';
import ReviewModal from './ReviewModal';

const TestimonialCard = ({ quote, name, title, avatar, onClick }) => (
  <div 
    className="testimonial-card flex flex-col shadow-lg rounded-lg overflow-hidden flex-shrink-0 mx-4 cursor-pointer"
    onClick={onClick}
  >
    <div className="bg-slate-800 p-8 text-center relative flex-grow">
      <div className="flex justify-center text-amber-400 mb-4">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>
      <FaQuoteLeft className="text-amber-400 text-4xl mb-4 mx-auto" />
      <p className="text-slate-400 italic text-sm">"{quote}"</p>
    </div>
    
    <div className="bg-slate-900 pt-16 pb-6 px-6 text-center relative">
      <div className="absolute left-1/2 -translate-x-1/2 -top-10">
        <div className="w-20 h-20 rounded-full bg-slate-700 border-4 border-slate-950 shadow-md overflow-hidden flex items-center justify-center text-slate-400">
           {/* Replaced 'IMG' with the actual image placeholder */}
           <img src={avatar} alt={name} className="w-full h-full object-cover" />
        </div>
      </div>
      <p className="font-bold text-white text-lg">{name}</p>
      <p className="text-sm text-slate-400">{title}</p>
    </div>
  </div>
);

const TestimonialSlider = () => {
  const [selectedReview, setSelectedReview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCardClick = (review) => {
    setSelectedReview(review);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedReview(null);
  };

  const duplicatedData = [...testimonialData, ...testimonialData, ...testimonialData];

  return (
    <section className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-center mb-16">
        <h2 className="text-3xl font-bold text-yellow-400 mb-2">
          Ours Reviewers
        </h2>
        <div className="line-container relative w-24 h-1 overflow-hidden">
          <div className="line bg-black h-full w-full"></div>
        </div>
      </div>

      <div className="testimonial-slider-container">
        <div className="testimonial-slider-track">
          {duplicatedData.map((item, index) => (
            <TestimonialCard 
              key={index}
              quote={item.quote}
              name={item.name}
              title={item.title}
              avatar={item.avatar}
              onClick={() => handleCardClick(item)}
            />
          ))}
        </div>
      </div>

      {/* Conditionally render the modal */}
      {isModalOpen && <ReviewModal review={selectedReview} onClose={closeModal} />}
    </section>
  );
}

export default TestimonialSlider;